import { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { deleteSurchargesMaintenance } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useDeleteSurchargesMaintenance = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useCallback((id) => {
    deleteSurchargesMaintenance(id)
      .then(async () => {
        await queryClient.invalidateQueries({
          queryKey: ['surchargesMaintenance']
        });
        showSnackbar({ message: t('deleteSuccessfully'), severity: 'success' });
      })
      .catch(() =>
        showSnackbar({
          severity: 'error',
          message: t('deleteWithErrors')
        })
      );
  }, []);
};
